<template>
  <div class="flex items-center">
      
      <vs-avatar v-if="params.data.paiment==undefined"  :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" @click="promptAddNewEvent"/>
      <vs-avatar v-if="params.data.paiment!=undefined"  :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" />
      <p  class="text-inherit hover:text-primary">{{ params.value }}</p>
    
    <!-- <div v-if="!params.data.paiment">
      <vs-avatar :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" @click="ajouter"/>
      <p  class="text-inherit hover:text-primary">{{ params.value }}</p>
    </div> -->
    
    <vs-prompt
        class="calendar-event-dialog"
        title="Participation"
        accept-text= "Ajouter"
        @accept="addParticipation"
        @cancel="vider"
        :is-valid="validForm"
        :active.sync="activePromptAddEvent">

        
        <div class="mt-5">
          <label class="text-sm opacity-75"></label>
        </div>
        <div class="mb-4">
         <vs-input class="w-full mt-4"  label="Montant payement" v-model="montand_payement" v-validate="'required'" name="montant" />
        </div>
        
        <div class="mt-5">
          <label class="text-sm opacity-75">Type payement</label>
          <v-select :options="type_choices" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="type_payement" class="mb-4 md:mb-0" v-validate="'required'"/>
        </div>
        </vs-prompt>
  </div>
</template>

<script>
    import vSelect from 'vue-select'
    export default {
      components: {
          vSelect,
      },
      
      data() {
    return {
      montand_payement: 0,
      type_payement: 0,
      activePromptAddEvent: false,
      type_choices: [
        { label: 'Une fois', value: '0' },
        { label: 'Par mois (4 seances)', value: '1' },
        // { label: 'Par tremester', value: '2' },
        
        
      ],
      }
      },
        name: 'CellRendererLink',
        computed: {
          url() {
            
            return "/application/formation/user-Vview/" + this.params.data.id

            // Below line will be for actual product
            // Currently it's commented due to demo purpose - Above url is for demo purpose
            // return "/apps/user/user-view/" + this.params.data.id
          }
        },
        methods:{
          promptAddNewEvent() {
          this.disabledFrom = false;
          this.addNewEventDialog();
          },
          addNewEventDialog() {
              this.montand_payement = 0
              this.type_payement = 0
              this.activePromptAddEvent = true
          },
          showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: title,
                text: text
              })
            },
          addParticipation(){
            
              const obj = {classe_id:this.$route.params.userId,candidat_id:this.params.data.id, montand_payement: this.montand_payement, type_paiment: this.type_payement.value }
             console.log(obj)
              this.$store.dispatch("classe/addParticipation", obj).catch(err => { console.error(err) }).then(()   => { this.$store.dispatch("classe/fetchCandidatsAjouter",this.$route.params.userId),this.showMessage('success', 'participation', 'candidat participer') })
              this.$store.dispatch("classe/fetchCandidatsAjouter",this.$route.params.userId)
              this.vider()
          }
        }
    }
</script>
